function m(e, n, t) {
  n /= 100, t /= 100;
  let a = (h, r = (h + e / 60) % 6) => t - t * n * Math.max(Math.min(r, 4 - r, 1), 0);
  return [a(5) * 255, a(3) * 255, a(1) * 255];
}
function M(e, n, t) {
  n /= 100, t /= 100;
  let a = n * Math.min(t, 1 - t), h = (r, i = (r + e / 30) % 12) => t - a * Math.max(Math.min(i - 3, 9 - i, 1), -1);
  return [h(0) * 255, h(8) * 255, h(4) * 255];
}
export {
  M as hsl2rgb,
  m as hsv2rgb
};
